import api from './api';
import { CallLog } from '../types';

export interface InitiateCallData {
  entity_type: 'lead' | 'customer' | 'tender';
  entity_id: number;
  phone_number: string;
  initiated_from?: 'web_click' | 'mobile_app' | 'desktop_dialer';
}

export interface CompleteCallData {
  call_log_id: number;
  call_status_id?: number;
  call_outcome?: string;
  notes?: string;
  call_duration_seconds?: number;
  next_call_date?: string;
  next_call_notes?: string;
}

export interface DeviceCallLog {
  id?: string;
  phone_number: string;
  call_date?: string;
  call_time?: string;
  duration?: number;
}

export interface SyncDeviceLogsData {
  call_logs: DeviceCallLog[];
  platform?: 'mobile_android' | 'mobile_ios';
}

export interface CallStatistics {
  total_initiated: number;
  total_completed: number;
  total_pending: number;
  completion_rate: number;
  average_time_to_complete_minutes: number;
  by_platform: Array<{ dialer_platform: string; count: number }>;
}

export const callDialerService = {
  initiate: async (data: InitiateCallData): Promise<{ call_log_id: number; phone_number: string; entity_name: string }> => {
    const response = await api.post('/api/calls/initiate', data);
    return response.data;
  },

  complete: async (data: CompleteCallData): Promise<CallLog> => {
    const response = await api.post('/api/calls/complete', data);
    return response.data.call_log;
  },

  getPending: async (filters?: { date_from?: string; date_to?: string }): Promise<CallLog[]> => {
    const response = await api.get('/api/calls/pending', { params: filters });
    return response.data;
  },

  syncDeviceLogs: async (data: SyncDeviceLogsData): Promise<{
    matched_contacts: any[];
    suggested_call_logs: any[];
    total_matched: number;
  }> => {
    const response = await api.post('/api/calls/sync-device-logs', data);
    return response.data;
  },

  getStatistics: async (): Promise<CallStatistics> => {
    const response = await api.get('/api/calls/statistics');
    return response.data;
  },
};




